module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.product) ? _c('div', {
    staticClass: "currency-field",
    domProps: {
      "innerHTML": _vm._s(_vm.formattedCurrency)
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b238602"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldCurrency.vue
// module id = 654
// module chunks = 0